import type { Terminal } from "../my-type"

export const getTerminals = () => {
  let terminals: Terminal[] = [{
    id: 0,
    code: "TPE",
    name: "桃園國際機場"
  },
  {
    id: 1,
    code: "TPE1",
    name: "桃園國際機場第一航廈"
  }, {
    id: 2,
    code: "TPE2",
    name: "桃園國際機場第二航廈"
  }, {
    id: 3,
    code: "TSA",
    name: "台北松山機場"
  }, {
    id: 4,
    code: "RMQ",
    name: "台中國際機場(尚未提供服務)"
  }, {
    id: 5,
    code: "KHH",
    name: "高雄國際機場(尚未提供服務)"
  }];

  return terminals;
}
